import { OverviewSectionProps } from "./types";

export const DEFAULT_TOOLTIPS: NonNullable<OverviewSectionProps["tooltips"]> = {
  category: {
    title: "Category",
    text: "The type of decarbonization activity this initiative falls under.",
    chip: "Input",
  },
  level: {
    title: "Level",
    text: "The level the initiative applies to.",
    chip: "Input",
  },
  site: {
    title: "Site",
    text: "The entity this initiative is attached to.",
    chip: "Input",
  },
  type: {
    title: "Initiative Type",
    text: "How the initiative is structured financially. Determines which inputs you need to fill in.",
    chip: "Input",
  },
  owner: {
    title: "Owner",
    text: "Person responsible for delivering this initiative.",
    chip: "Input",
  },
  priority: {
    title: "Priority",
    text: "An internal label for sorting and filtering. Doesn't affect any calculation.",
    chip: "Input",
  },
  description: {
    title: "Description",
    text: "A short summary of what the initiative does.",
    chip: "Input",
  },
};
